import { Subject } from 'rxjs/Subject';
var ServiceName = "PubSub Service";
var PubSubService = (function () {
    function PubSubService() {
        this.events = {};
    }
    PubSubService.prototype.$sub = function (event, callback, error, complete) {
        if (!event) {
            throw new Error("[" + ServiceName + "] => Subscription method must get event name.");
        }
        if (this.events[event] === undefined) {
            this.events[event] = new Subject();
        }
        if (typeof callback !== 'function') {
            return this.events[event].asObservable();
        }
        else {
            return this.events[event].asObservable().subscribe(callback, error, complete);
        }
    };
    PubSubService.prototype.$pub = function (event, eventObject) {
        if (!event) {
            throw new Error("[" + ServiceName + "] => Publish method must get event name.");
        }
        else if (!this.events[event]) {
            return;
        }
        this.events[event].next(eventObject);
    };
    return PubSubService;
}());
export { PubSubService };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/service/pubSub.service.ts.pre-build-optimizer.js